import clsx from 'clsx';
import type { UsersResponse } from '@shared/api/rest/users';
import styles from './styles/userInfo.module.css';

interface IUserInfo {
  value?: UsersResponse;
  children?: React.ReactNode;
}

export const UserInfo = (props: IUserInfo) => {
  if (!props.value) return null;
  return (
    <div className={clsx(styles[props.value.locked ? 'user-blocked' : ''], 'flex-auto min-w-0')}>
      <div className='flex-auto min-w-0'>{props.children}</div>
    </div>
  );
};
